module.exports = __webpack_public_path__ + "static/img/support-fs.1439dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/support-fs.png
// module id = 441
// module chunks = 1